import { render } from "./TreeFolderComponent.vue?vue&type=template&id=168c45c3"
import script from "./TreeFolderComponent.vue?vue&type=script&lang=js"
export * from "./TreeFolderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__